import {Tile as TileLayer} from 'ol/layer.js';
import XYZ from 'ol/source/XYZ.js';
import {Layer} from './Layer.js';
import { getBaseMapStyle } from './config.js';

export class BaseLayer extends Layer {
    constructor(map, settings = {}){
        settings['name'] = "basemap";
        settings['visible'] = true;
        super(map, settings);
        this.getState();
        let url = this.map.server + "/cgi-bin/tilecache/tc.php?product="+this.settings['type']+"&x={x}&y={-y}&z={z}";
        if( this.settings['type'] == 'esri_terr' )
            url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}";
        if( this.settings['type'] == 'esri_road' )
            url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
        if( this.settings['type'] == 'esri_sat' )
            url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.layer = new TileLayer({
                "source": new XYZ({
                        "url": url
                        }),
                "visible": this.settings['visible']
                });
    }

    set( key, val ){
        if( key == "type" ){
            this.settings['type'] = val;
            let url = this.map.server + "/cgi-bin/tilecache/tc.php?product="+this.settings['type']+"&x={x}&y={-y}&z={z}";
            if( this.settings['type'] == 'esri_terr' )
                url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}";
            if( this.settings['type'] == 'esri_road' )
                url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
            if( this.settings['type'] == 'esri_sat' )
                url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
            this.layer.getSource().setUrl(url);
            let style = getBaseMapStyle( val );
            console.info( 'set basemap', val, style );
            for( let lay in this.map.layers ){
                if( this.map.layers[lay].class == "wms" ){
                    console.info( "xx", this.map.layers[lay].name ); 
                    this.map.layers[lay].setStyle(style);
                }
            }
        }

        return 1;
    }
}
